import { render, staticRenderFns } from "./publicNavigation.vue?vue&type=template&id=0ad2e48c&scoped=true"
import script from "./publicNavigation.vue?vue&type=script&lang=js"
export * from "./publicNavigation.vue?vue&type=script&lang=js"
import style0 from "./publicNavigation.vue?vue&type=style&index=0&id=0ad2e48c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad2e48c",
  null
  
)

export default component.exports